import { regexEscape } from '@magnetic/lib';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const filterCategories = /* @__PURE__ */ __name((autocomplete, value, maxShownOptions, maxShownCategories) => {
  const maxPerCategory = Math.ceil(maxShownOptions / maxShownCategories);
  const filteredCategories = [];
  const reg = new RegExp(`(${regexEscape(value)})`, "i");
  for (const category of autocomplete) {
    const filteredOptions = [];
    for (const option of category.options) {
      if (reg.test(option)) {
        filteredOptions.push(option);
      }
    }
    if (filteredOptions.length > 0) {
      filteredCategories.push({
        ...category,
        options: filteredOptions.slice(0, maxPerCategory)
      });
    }
    if (filteredCategories.length >= maxShownCategories) {
      break;
    }
  }
  return filteredCategories;
}, "filterCategories");

export { filterCategories };
//# sourceMappingURL=filter-categories.js.map
